// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"662bea8d9895811514d9","293":"b1dfb70120cd8e5f1f64","518":"921b0cee22371b505880","779":"f6fd075557a2497aeb53"}[chunkId] + ".js";
};